export default "__VITE_ASSET__DCeo4IUh__"